const useIsAdmin = () => {
  return localStorage.getItem('MCPicklers-Admin') === 'true';
};

export default useIsAdmin;
